(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('activityIndicator', function() {
    return {
      restrict: 'E',
      scope: { 'type': '@', 'borderTop': '@', 'borderBottom': '@' },
      templateUrl: '/m/activityIndicator.html?_hv=bd2bd03'
    };
  });
})(window, window.angular);
